// TUS COMPROBACIONES DE HOY — el aviso con el "ok".
//
// Hay cosas que hay que hacer todos los días a una hora y que no dejan rastro: revisar los gabinetes
// al cerrar, mirar los baños, comprobar el autoclave. Se recuerdan de memoria, se recuerdan a veces,
// y cuando algo falla nadie puede decir si se hizo.
//
// POR QUE HAY QUE DARLE AL OK, y no basta con que aparezca: un aviso que solo se enseña y se va no
// cambia nada — se mira y se sigue a lo que se estaba haciendo. Al pedir confirmación pasan dos cosas:
// hay que ir a mirarlo de verdad para poder cerrarlo, y queda escrito que ese día se hizo y quién.
//
// SOLO APARECE CUANDO YA ES SU HORA. Una comprobación de las 14:45 asomando a las nueve de la mañana
// es ruido: se cierra por quitarla de en medio y deja de significar nada.
import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import api from '../services/api'
import { useToast } from '../context/ToastContext'
import { Ico } from './ui'
import { t as i18nT, tx } from '../utils/i18n'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

export default function ComprobacionesHoy() {
  const toast = useToast()
  const [abierta, setAbierta] = useState(null)   // tarea desplegada para escribir una nota
  const [nota, setNota] = useState('')
  const { data, refetch } = useQuery({
    queryKey: ['comprobaciones-hoy'],
    queryFn: () => api.get('/tareas-recurrentes/mias').then(r => r.data).catch(() => ({ tareas: [], pendientes: 0 })),
    // Cada dos minutos: es lo que hace que aparezca sola al llegar su hora sin tener que recargar.
    refetchInterval: 120000,
  })
  const pendientes = (data?.tareas || []).filter(t => !t.hecha && t.le_toca_ya)
  if (!pendientes.length) return null

  const marcar = async (t) => {
    try {
      await api.post(`/tareas-recurrentes/${t.id}/ok`, { nota: abierta === t.id ? nota.trim() : '' })
      setAbierta(null); setNota('')
      toast.success(i18nT('components.ComprobacionesHoy.anotado', 'Anotado'))
      refetch()
    } catch (e) { toast.error(e.response?.data?.error || i18nT('components.ComprobacionesHoy.no_se_ha_podido_anotar', 'No se ha podido anotar')) }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '14px' }}>
      {pendientes.map(t => (
        <div key={t.id} style={{ background: 'color-mix(in srgb, var(--info) 10%, var(--surface))', border: '1px solid color-mix(in srgb, var(--info) 45%, var(--border))', borderRadius: '10px', padding: '11px 13px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
            <span style={{ color: 'var(--info)', display: 'flex', flexShrink: 0 }}><Ico n="clock" s={17} /></span>
            <div style={{ minWidth: 0, flex: 1 }}>
              <div style={{ fontSize: '13.5px', fontWeight: 700 }}>{t.titulo}</div>
              {t.detalle && <div style={{ fontSize: '12.5px', color: 'var(--text-secondary)', marginTop: '2px' }}>{t.detalle}</div>}
              <div style={{ fontSize: '11.5px', color: 'var(--text-muted)', marginTop: '2px' }}>{tx('components.ComprobacionesHoy.de_las', 'De las {{hora}}', { hora: t.hora })}</div>
            </div>
            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
              {/* Escribir algo es OPCIONAL. Exigirlo convertiría un gesto de dos segundos en uno que
                  se pospone, y una comprobación pospuesta no se hace. */}
              <button onClick={() => { setAbierta(abierta === t.id ? null : t.id); setNota('') }}
                style={{ background: 'none', border: 'none', padding: 0, fontSize: '12px', fontWeight: 700, color: 'var(--text-secondary)', cursor: 'pointer' }}>
                {abierta === t.id ? i18nT('components.ComprobacionesHoy.sin_nota', 'Sin nota') : i18nT('components.ComprobacionesHoy.anadir_nota', 'Añadir nota')}
              </button>
              <button onClick={() => marcar(t)}
                style={{ background: 'var(--info)', color: '#fff', border: 'none', borderRadius: '8px', padding: '7px 14px', fontSize: '12.5px', fontWeight: 800, cursor: 'pointer' }}>
                {i18nT('components.ComprobacionesHoy.hecho', 'Hecho')}
              </button>
            </div>
          </div>
          {abierta === t.id && (
            <input autoFocus value={nota} onChange={e => setNota(e.target.value)}
              placeholder={i18nT('components.ComprobacionesHoy.algo_que_anotar_falta_papel', 'Algo que anotar (falta papel en el baño 2…)')}
              onKeyDown={e => { if (e.key === 'Enter') marcar(t) }}
              style={{ width: '100%', marginTop: '9px', padding: '8px 10px', borderRadius: '8px', border: '1px solid var(--border)', background: 'var(--surface)', fontSize: '13px', color: 'var(--text)', boxSizing: 'border-box' }} />
          )}
        </div>
      ))}
    </div>
  )
}
